import React, { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { brand } from '../config/brand';
import { useAuth } from '../hooks/useAuth';
import CookieConsent from './CookieConsent';

const { FiMenu, FiX, FiArrowUpRight } = FiIcons;
const links = [
  ['Home', '/'],
  ['AI Coaching', '/coaching'],
  ['How It Works', '/how-it-works'],
  ['Pricing', '/pricing'],
  ['For Organisations', '/organisations'],
  ['Resources', '/resources'],
  ['About', '/about'],
  ['Contact', '/contact']
];

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { session } = useAuth();

  return (
    <div className="site-shell">
      <header className="header">
        <Link className="brand" to="/">
          <span className="brand-mark">G</span>
          <span>{brand.name}</span>
        </Link>
        <button className="icon-button mobile-only" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          <SafeIcon icon={open ? FiX : FiMenu} />
        </button>
        <nav className={open ? 'nav open' : 'nav'} aria-label="Main navigation">
          {links.map(([label, path]) => (
            <NavLink key={path} to={path} onClick={() => setOpen(false)}>{label}</NavLink>
          ))}
          <NavLink to={session ? '/account' : '/login'}>{session ? 'Account' : 'Login'}</NavLink>
          <Link className="button small" to="/pricing">
            Get Started <SafeIcon icon={FiArrowUpRight} />
          </Link>
        </nav>
      </header>
      <main><Outlet /></main>
      <footer className="footer">
        <div>
          <Link className="brand footer-brand" to="/"><span className="brand-mark">G</span>{brand.name}</Link>
          <p>{brand.tagline}</p>
        </div>
        <div className="footer-links">
          <Link to="/responsible-ai">Responsible AI</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <a href={`mailto:${brand.supportEmail}`}>Support</a>
        </div>
        <p className="disclaimer">AI coaching supports personal and professional development. It is not a substitute for medical, psychological, legal, financial or other regulated professional advice.</p>
      </footer>
      <CookieConsent />
    </div>
  );
}